import { render, staticRenderFns } from "./tool-edit-info-recommend.vue?vue&type=template&id=2407cdb1&scoped=true&"
import script from "./tool-edit-info-recommend.vue?vue&type=script&lang=js&"
export * from "./tool-edit-info-recommend.vue?vue&type=script&lang=js&"
import style0 from "./tool-edit-info-recommend.vue?vue&type=style&index=0&id=2407cdb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2407cdb1",
  null
  
)

export default component.exports